<template>
    <div class="banners">
        <div class="container">
            <div class="row justify-content-center">
                <div v-for="banner in filtered_banners" :key="banner.ID" :class=" `mb-3 col-md-${ area == 'footer' || 'acima-do-destaque-na-home' ? '12' : area == 'subfooter' ? '6' : '12' }` ">
                    <TreineBanner :banner="banner" :area="area"></TreineBanner>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import TreineBanner from '@/components/TreineBanner'


export default {
    props : [ 'area' ],
    components : {
        TreineBanner
    },
    data () {
        return {
            filtered_banners : [],
        }
    },
    computed: {
        ...mapGetters([
            'banners',
        ])
    },
    created(){
        this.filtered_banners = this.banners.filter(b => b.areas.includes(this.area) )
    },
    methods: {
        displayCarousel() {
            return this.area === 'acima-do-destaque-na-home' && this.filtered_banners.length > 1
        },
        carouselBanners() {
            return this.filtered_banners.slice(0,3)
        }
    }
}
</script>
